import React, { useEffect, useRef, useState } from "react";
import moment from "moment";
import { APLadger } from "../../Configuration/API_URL";
import Header from "../../Components/Header";
import { Client_Search } from "../../Configuration/API_URL";
import ReportTableHeader from "../../Components/ReportTables/ReportTableHeader";
import Loader from "../../Components/Common/Loader";
import {
  AESEncryption,
  ApiResDecrypt,
  checkDateRange,
  compareDate,
  decryptData,
  encryptData,
  noDataFound,
} from "../../CommonMethhods/CommonMethods";
import { Constants } from "../../CommonMethhods/Constants";
import LoaderForSearch from "../../Components/Common/LoaderForSearch";
import { toast } from "react-toastify";
import InterestReportTable from "../../Components/ReportTables/InterestReportTable";
import { useDebounce } from "../../Components/useDebounce";
import SingleSignOnSideBar from "../../Components/SingleSignOnSideBar";
import { Partner_Reports,  } from "../../Configuration/Partner_URL";
import DurationChangeComponent from "../Reports/DurationChangeComponent";
import FromdateComponent from "../Reports/FromdateComponent";
import TodateComponent from "../Reports/TodateComponent";
import ApLedgerReport from "../../Components/ReportTables/ApLedgerReport";
import Select from "react-select";
import axiosInstance from "../../CommonMethhods/axiosInstance";


function APLedgerReport() {
  const storeToken = localStorage.getItem("ssoToken");
  // const userType = localStorage.getItem("userType").toLowerCase();
  const userType = localStorage.getItem("partnerType").toLowerCase();
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [seg, setSeg] = useState("dpc");
  const [data, setData] = useState();
  const [errorResp, setErrorResp] = useState("");
  const [page, setPage] = useState(1);
  const [scrollLoader, setScrollLoader] = useState(false);
  const [loader, setLoader] = useState(false);
  const [smallLoaderExcel, setSmallLoaderExcel] = useState(false);
  const [smallLoaderPdf, setSmallLoaderPdf] = useState(false);
  const [smallLoaderMail, setSmallLoaderMail] = useState(false);
  const [serverError, setServerError] = useState(false);
  const [clientCode, setClientCode] = useState("");
  const [count, setCount] = useState();
  const [clientList, setClientList] = useState([]);
  const [show, setShow] = useState(false);
  const [nameError, setNameError] = useState(false);
  const [mainError, setMainError] = useState(false);
  const [errorGrid, setErrorGrid] = useState(false);
  const [totalMTF, setTotalMTF] = useState();
  const [customShow, setCustomShow] = useState(true)
  const [selectDuration,setSelectDuration]=useState("")
  const [errorRespMo, setErrorRespMo] = useState("");
  const [errorfromDataResp, setfromDateErrorResp] = useState("");
  const [errortoDataResp, settoDateErrorResp] = useState("");


  
//  const customStyles = {
//         control: (provided, state) => ({
//             ...provided,
//             boxShadow: "none",
//             border: "1px solid #ccc",
//             "&:hover": {
//                 border: "1px solid #ccc",
//             },
//         }),
//     };

  const getCurrentFinancialYear = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = today.getMonth() + 1;
  
    if (month < 4) {
      return `${year - 1}-${String(year).slice(2)}`;
    } else {
      return `${year}-${String(year + 1).slice(2)}`;
    }
  };
  
  const options = [
    { value: "2023-24", label: "2023-24" },
    { value: "2024-25", label: "2024-25" },
    { value: "2025-26", label: "2025-26" },
    { value: "2026-27", label: "2026-27" },
    { value: "2027-28", label: "2027-28" },
  ];
  
  // ✅ Set default selected option (React Select expects full object)
  const [selectedMonth, setSelectedMonth] = useState(() => {
    const currentFY = getCurrentFinancialYear();
    return options.find((opt) => opt.value === currentFY) || null;
  });

  const debouncedValue = useDebounce(clientCode, 1000);
  useEffect(() => {
    handleClientName(debouncedValue);
  }, [debouncedValue]);

  if (fromDate === "" || toDate === "") {
    const current = new Date();
    const CurrentYear = current.getFullYear();
    const CurrentMonth = current.getMonth();
    if (CurrentMonth < 4) {
      const newYear = `04-01-${CurrentYear - 1}`;
      const date = `${current.getMonth() + 1
      }-${current.getDate()}-${current.getFullYear()}`;
      const date1 = moment(date, "MM-DD-YYYY").format("MM-DD-YYYY");
      setFromDate(newYear);
      setToDate(date1);
    } else {
      const newYear = `04-01-${CurrentYear}`;
      const date = `${current.getMonth() + 1
      }-${current.getDate()}-${current.getFullYear()}`;
      const date1 = moment(date, "MM-DD-YYYY").format("MM-DD-YYYY");
      setFromDate(newYear);
      setToDate(date1);
    }
  }

  
  //search api

  // async function searchApiDetail(code, NoPage) {
  //   let payloadValue = {
  //     keyword: code,
  //     Status: "",
  //     PageNo: NoPage,
  //     PageSize: 10,
  //   };
  //   const partnerPayload = {
  //     clientCode: code,
  //     page: NoPage,
  //     pageSize: 10,
  //   };

  //   const encPayload =
  //     userType === "partner"
  //       ? encryptData(JSON.stringify(partnerPayload))
  //       : AESEncryption(payloadValue);
  //   try {
  //     const getSearchDetail = await axios.post(
  //       userType === "partner"
  //         ? Partner_Reports.Client_Search_Partner_URL
  //         : Client_Search.Search_URL,
  //       userType === "partner" ? encPayload : `"${encPayload}"`,
  //       {
  //         headers: {
  //           "Content-Type":
  //             userType === "partner" ? "text/plain" : "application/json",
  //           Authorization: `Bearer ${storeToken}`,
  //           reserv: 1,
  //         },
  //       }
  //     );

  //     const res =
  //       userType === "partner"
  //         ? JSON.parse(decryptData(getSearchDetail?.data))
  //         : ApiResDecrypt(getSearchDetail?.data);
  //     if (res?.status === 0) {
  //       setCount(res?.data?.TotalCount);
  //       setNameError(false);
  //       if (page > 1) {
  //         setClientList((prev) => {
  //           return [...prev, ...res?.data?.clients];
  //         });
  //       } else {
  //         setClientList(res?.data?.clients);
  //       }
  //     } else {
  //       setNameError(res?.message);
  //     }
  //   } catch (error) {
  //     console.log(error);
  //   } finally {
  //     setScrollLoader(false);
  //     setMainError(false);
  //   }
  // }


  async function searchApiAPCode() {
  try {
    const getSearchDetail = await axiosInstance.get(
      APLadger.GetAPList,
    );

    const res = ApiResDecrypt(getSearchDetail?.data);
    if (res?.status === 0) {
      setNameError(false);
      setClientList(res?.data);
      // 👇 If only one client found, set it as default
      if (res?.data?.length === 1) {
      setClientCode(res?.data[0].apCode); // adjust key name if different
    }
    } else {
      setNameError(res?.message);
    }
  } catch (error) {
    console.error(error);
  } finally {
    setScrollLoader(false);
    setMainError(false);
  }
}

console.log('client code', clientCode)


  const handleScroll = async (e) => {
    const a = e.target;
    if (a.scrollTop + a.offsetHeight + 1 >= a.scrollHeight && !scrollLoader) {
      if (!(count <= 10 * page)) {
        setPage((prev) => prev + 1);
        setScrollLoader(true);
      }
    }
  };

  function handleClientName(data) {
    if (data) {
      searchApiAPCode(data, 1);
      setScrollLoader(true);
      setClientList([]);
      setPage(1);
    }
  }

  useEffect(() => {
    // if (page > 1) {
      searchApiAPCode();
    // }
  }, []);

  //search api end

  //trade summary report api
  const getInterestReport = async (fileView, mainLoader = false) => {
    setSmallLoaderExcel(fileView === "excel");
    setSmallLoaderPdf(fileView === "pdf");
    setSmallLoaderMail(fileView === "mail");
    setLoader(mainLoader && fileView === "grid");
    let payloadValue = {
      appCode: clientCode,
      finYear: "2025-26",
      fromDate: fromDate,
      toDate: toDate,
      fileType: fileView,
    //   seg: seg,
    };
    console.log('payloadValue',payloadValue)
    let encPayload = AESEncryption(payloadValue);
    try {
      const getDetails = await axiosInstance.post(
        APLadger.GetAPLadgerBalanceDetails,
        `"${encPayload}"`,
      );
      const res = ApiResDecrypt(getDetails?.data);
      if (res?.status === 0) {
        console.log("res ineterest", res.data)
        if (fileView === "grid") {
          if (seg === "dpc") {
            //setTotalMTF(res?.data?.totalIntChrg);
            setData(res?.data);
          } else if (seg === "mtf") {
            setData(res?.data);
            setTotalMTF(res?.data?.totalMtf);
          } else if (seg === "prop") {
            setData(res?.data);
            // setTotalMTF(res?.data?.totalAllocationFromPropCount);
          }
        } else if (fileView === "excel") {
          window.open(res?.data, "_self", "noopener,noreferrer");
        } else if (fileView === "pdf") {
          window.open(res?.data, "_blank", "noopener,noreferrer");
        } else {
          toast.success("Mail sent successfully");
        }
      } else {
        if (fileView !== "grid") {
          toast.error(res?.message);
        } else {
          setErrorGrid(res?.message);
          setData();
        }
      }
    } catch (error) {
      console.log(error);
      if (fileView !== "grid") {
        toast.error(error?.message);
      } else {
        setServerError(error?.message);
        setData();
      }
    } finally {
      setLoader(false);
      setSmallLoaderExcel(false);
      setSmallLoaderPdf(false);
      setSmallLoaderMail(false);
    }
  };

  //trade summary report api end

  // const handleOnClick = (e) => {
  //   // debugger
  //   setShow(false);
  //   setMainError("");

  //   // ✅ Check if clientCode selected
  //   if (!clientCode) {
  //     setMainError("Please select Client Code");
  //     return;
  //   }
  //     if (e.target.value) {
  //         if (
  //           compareDate(fromDate) &&
  //           compareDate(toDate) &&
  //           checkDateRange(fromDate, toDate)
  //         ) {
  //           getInterestReport(e.target.value, true);
  //           setErrorResp("");
  //         } else {
  //           setErrorResp("Please Select Correct Date");
  //         }
  //     }
  // };


  const handleOnClick = (e) => {
  setShow(false);
  setMainError("");
  setErrorResp(""); // clear any old error

  // ✅ 1. Check if client code selected
  if (!clientCode) {
    setMainError("Please select Client Code");
    return;
  }

  // ✅ 2. Validate FROM DATE
  if (!fromDate) {
    setfromDateErrorResp("Please select From Date");
    return;
  }
  if (!compareDate(fromDate)) {
    setfromDateErrorResp("Please select a valid From Date");
    return;
  }

  // ✅ 3. Validate TO DATE
  if (!toDate) {
    settoDateErrorResp("Please select To Date");
    return;
  }
  if (!compareDate(toDate)) {
    settoDateErrorResp("Please select a valid To Date");
    return;
  }
  

    // ✅ 4. Validate Date Range (From <= To)
  const from = new Date(fromDate);
  const to = new Date(toDate);

  if (from > to) {
    setfromDateErrorResp("From Date should not be greater than To Date");
    return;
  }

  // // ✅ 4. Validate Date Range (From <= To)
  // if (!checkDateRange(fromDate, toDate)) {
  //   setErrorResp("To Date must be after From Date");
  //   return;
  // }

  // ✅ 5. Proceed only if button clicked with value
  if (e.target.value) {
    getInterestReport(e.target.value, true);
    setErrorResp("");
  }
};


  function formatDate(date) {
    return moment(date, "MM-DD-YYYY").format("YYYY-MM-DD");
  }

  const handleSegmentChange = (e) => {
    setData();
    setErrorGrid(false);
    setSeg(e.target.value);
  };

  const handleFromDateChange = (e) => {
    setData();
    setErrorGrid(false);
    let c = e.target.value;
    const d = moment(c, "YYYY-MM-DD").format("MM-DD-YYYY");
    setFromDate(d);
    setErrorResp("");
    setfromDateErrorResp("");
    setServerError(false);
  };
  const handleToDateChange = (e) => {
    setData();
    setErrorGrid(false);
    let c = e.target.value;
    const d = moment(c, "YYYY-MM-DD").format("MM-DD-YYYY");
    setToDate(d);
    setErrorResp("");
    settoDateErrorResp("");
    setServerError(false);
  };

  const currentDate = new Date();
  const yyyy = currentDate.getFullYear();
  let mm = currentDate.getMonth() + 1;
  let dd = currentDate.getDate();
  if (dd < 10) dd = "0" + dd;
  if (mm < 10) mm = "0" + mm;
  const FormatedDate = dd + "/" + mm + "/" + yyyy;
  const DateReverse = FormatedDate.split("/").reverse().join("-");

  const onChangeDuration=()=>{
    setErrorGrid(false);
    setData();
    setErrorResp(false);
    setServerError(false);
  }

//    const customStyles = {
//   control: (provided, state) => ({
//     ...provided,
//     minHeight: '32px',        // reduce height
//     height: '32px',
//     borderRadius: '6px',
//     borderColor: state.isFocused ? '#2684FF' : '#ccc',
//     boxShadow: state.isFocused ? '0 0 0 1px #2684FF' : 'none',
//     '&:hover': {
//       borderColor: '#2684FF',
//     },
    
//   }),
//   valueContainer: (provided) => ({
//     ...provided,
//     height: '32px',
//     padding: '0 8px',
//   }),
//   input: (provided) => ({
//     ...provided,
//     margin: 0,
//     padding: 0,
    
//   }),
//   indicatorsContainer: (provided) => ({
//     ...provided,
//     height: '32px',
//   }),
//   dropdownIndicator: (provided) => ({
//     ...provided,
//     padding: '4px',
//   }),
//   clearIndicator: (provided) => ({
//     ...provided,
//     padding: '4px',
//   }),
//   menu: (provided) => ({
//     ...provided,
//     zIndex: 9999, // ensures dropdown overlays other elements
//     cursor: "not-allowed !important"
//   }),
// };


const customStyles = {
  control: (provided, state) => ({
    ...provided,
    minHeight: '32px',
    height: '32px',
    borderRadius: '6px',
    borderColor: state.isFocused ? '#2684FF' : '#ccc',
    backgroundColor: state.isDisabled ? '#f5f5f5' : '#fff',
    cursor: state.isDisabled ? 'not-allowed' : 'default',
    pointerEvents: state.isDisabled ? 'auto' : 'all', // allow hover cursor
    '&:hover': {
      borderColor: state.isDisabled ? '#ccc' : '#2684FF',
      cursor: state.isDisabled ? 'not-allowed' : 'pointer',
    },
  }),
  valueContainer: (provided) => ({
    ...provided,
    height: '32px',
    padding: '0 8px',
  }),
  indicatorsContainer: (provided, state) => ({
    ...provided,
    height: '32px',
    cursor: state.isDisabled ? 'not-allowed' : 'pointer',
  }),
};


  return (
    <>
      <Header portal={"RM"} />
      {/* <Sidebar /> */}
      <SingleSignOnSideBar />
      <main id="main-content" className="reports interest-report-wrapper">
        <div className="card-box">
          <div>
            <h2 className="report-title">AP Ledger Report</h2>
          </div>
          <div class="row input-field-wrapper">
            <div className="col-md-2 col-sm-3 col-6">
              <div className="row d-flex justify-content-between">
                <div className="form-group">
                  <label className="form-label">
                    {Constants.AP_Search} 
                    <span style={{ color: "red" }}>*</span>        
                  </label>
                  <div className="rm-custom-dropdown">
                    <input
                      type="text"
                      name="search-text"
                      className="input-st"
                      placeholder="Search here..."
                      autoComplete="off"
                      onInput={(e) => {
                      const start = e.target.selectionStart;
                      const end = e.target.selectionEnd;

                      let input = e.target.value.toUpperCase();
                      input = input.replace(/[^a-zA-Z0-9 ]/g, "");
                              input = input.replace(/\s{2,}/g, " "); 
                              input = input.replace(/^\s+/, ""); 

                      if (input.length > 100) input = input.slice(0, 100);
                      e.target.value = input;
                      e.target.setSelectionRange(start, end);
                    }}
                      value={clientCode}
                      onChange={(e) => {
                        setClientCode(e.target.value.toUpperCase());
                        setShow(true);
                        setErrorGrid(false);
                      }}
                    />
                    <button
                      className="rm-dropdown-btn"
                      onClick={() => setShow(!show)}
                    >
                      <span className="icon-right-arrow-triangle"></span>
                    </button>
                    {show && (
                      <>
                        <ul
                          className="rm-mapping-ap border-0"
                          onScroll={(e) => handleScroll(e)}
                        >
                          {clientList &&
                            clientList.map((item, i) => (
                              <li
                                key={i}
                                className="rm-maping-item-wrapper"
                                onClick={() => {
                                  setClientCode(item?.apCode);

                                  setShow(false);
                                }}
                              >
                                  <>
                                    <div> {item?.apCode}</div>
                                    <div> {item?.sapCode}</div>
                                  </>                           
                              </li>
                            ))}
                          {scrollLoader && !loader && (
                            <div className="loader-center">
                              <LoaderForSearch />
                            </div>
                          )}
                          {nameError && !scrollLoader && (
                            <li
                              className="rm-maping-item-wrapper"
                              style={{
                                borderBottom: "none",
                                fontSize: "12px",
                              }}
                            >
                              {nameError}
                            </li>
                          )}
                        </ul>
                      </>
                    )}
                  </div>
                  {mainError && (
                    <span className="to-apcode-error">{mainError}</span>
                  )}
                </div>
              </div>
            </div>

            {/* <div className="col-md-2 col-sm-3 col-6">
              <div className="form-group">
                <label className="form-label">Segment:</label>
                <select onChange={handleSegmentChange}>
                  <option value="dpc">Delay Payment</option>
                  <option value="mtf">MTF</option>
                  {userType != "partner" ? <option value="prop">PROP</option> : ""}
                </select>
              </div>
            </div> */}
            {/* <div className="col-md-2 col-sm-3 col-6">
              <div className="form-group">
                <DurationChangeComponent
                  setCustomShow={setCustomShow}
                  setFromDate={setFromDate}
                  setToDate={setToDate}
                  onChangeDuration={onChangeDuration}
                  setSelectDuration={setSelectDuration}
                  selectDuration={selectDuration}
                />
              </div>
              {errorResp && !selectDuration && (
                <span className="duration-date-error">{errorResp}</span>
              )}
            </div> */}
             <div className="col-md-3 col-sm-3 col-6">
    <label className="form-label">Select Financial Year:<span style={{ color: "red" }}>*</span></label>
    
    <div className="form-group">
      <Select
        options={options}
        value={selectedMonth}
        onChange={(value) => {
          setSelectedMonth(value);
          setErrorRespMo("");
        }}
        placeholder="Search year..."
        isSearchable={true}
        styles={customStyles}
        isDisabled
      />
      {errorRespMo && (
        <span className="to-date-error month-error">{errorRespMo}</span>
      )}
    </div>
  </div>
            {customShow && <div className="col-md-3 col-sm-3 col-6">
                <FromdateComponent
                  fromDate={handleFromDateChange}
                  formatDate={formatDate(fromDate)}
                  DateReverse={DateReverse}
                  errorResponse={errorfromDataResp}
                  clientWiseReportForCustomCalanderIcon={true}
                />
            </div>}
            {customShow && <div className="col-md-3 col-sm-3 col-6">
                <TodateComponent
                  toDate={handleToDateChange}
                  formatToDate={formatDate(toDate)}
                  DateReverse={DateReverse}
                  errorResponse={errortoDataResp}
                  clientWiseReportForCustomCalanderIcon={true}
                />
            </div>}
          </div>

          <div className="text-center search-btn-wrapper">
            <button
              value="grid"
              className="send-message"
              onClick={handleOnClick}
            >
              {Constants.Search}
            </button>
          </div>

          <div>
            <ReportTableHeader
              // showEmailBtn={true}
              smallLoaderExcel={smallLoaderExcel}
              smallLoaderMail={smallLoaderMail}
              smallLoaderPdf={smallLoaderPdf}
              handleOnClick={handleOnClick}
            />
          </div>
          <div className="for-grid-section">
            {loader ? (
              <div className="loader-alignment">
                <Loader />
              </div>
            ) : data ? (
              <div>
                <ApLedgerReport
                  data={data}
                  seg={seg}
                  totalMTF={totalMTF}
                />
              </div>
            ) : serverError ? (
              <h4 className="report-error-message">
                {noDataFound(serverError)}
              </h4>
            ) : errorGrid ? (
              noDataFound(errorGrid)
            ) : (
              ""
            )}
          </div>
        </div>
      </main>
    </>
  );
}

export default APLedgerReport;
